import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import { projectsData } from '../data/projectsData';
import { FaArrowLeft } from 'react-icons/fa';

const AllProjects = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="container" style={{ paddingTop: '100px', paddingBottom: '100px', minHeight: '100vh' }}>
      <Link to="/" style={{ display: 'inline-flex', alignItems: 'center', gap: '8px', color: 'var(--accent-cyan)', marginBottom: '3rem', textDecoration: 'none', fontWeight: 600 }}>
        <FaArrowLeft /> Back to Home
      </Link>

      <motion.div
        initial={{ opacity: 0, y: 30 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.6 }}
        style={{ marginBottom: '4rem' }}
      >
        <h1 style={{ fontSize: 'clamp(2.5rem, 5vw, 4rem)', marginBottom: '1rem' }} className="text-gradient">
          Complete Project Archive
        </h1>
        <p style={{ fontSize: '1.2rem', color: 'var(--text-secondary)', maxWidth: '800px' }}>
          A comprehensive look at 25+ projects spanning my 25-year journey. From massive AI and Cloud transformations to foundational startup-building and fullstack enterprise architecture.
        </p>
      </motion.div>

      <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(320px, 1fr))', gap: '2rem' }}>
        {projectsData.map((project, index) => (
          <motion.div
            key={project.id || index}
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-50px" }}
            whileHover={{ y: -8, boxShadow: '0 10px 30px rgba(0, 240, 255, 0.15)' }}
            transition={{ duration: 0.4 }}
            className="glass-panel"
            style={{ padding: '2rem', display: 'flex', flexDirection: 'column', height: '100%' }}
          >
            <h3 style={{ fontSize: '1.4rem', marginBottom: '0.5rem', color: 'var(--text-primary)' }}>{project.title}</h3>
            <h4 style={{ fontSize: '1rem', color: 'var(--accent-purple)', marginBottom: '1rem', fontWeight: 500 }}>{project.role}</h4>
            <p style={{ color: 'var(--text-secondary)', lineHeight: 1.6, flexGrow: 1, marginBottom: '1.5rem', fontSize: '0.95rem' }}>
              {project.shortDesc}
            </p>
            
            <div style={{ display: 'flex', flexWrap: 'wrap', gap: '6px', marginBottom: '1.5rem' }}>
              {(project.tech || []).slice(0, 4).map((t, i) => (
                <span key={i} style={{ fontSize: '0.75rem', color: 'var(--accent-cyan)', background: 'rgba(0,240,255,0.05)', padding: '4px 8px', borderRadius: '12px' }}>
                  {t}
                </span>
              ))}
              {(project.tech && project.tech.length > 4) && (
                <span style={{ fontSize: '0.75rem', color: 'var(--text-secondary)', padding: '4px 8px' }}>+{project.tech.length - 4}</span>
              )}
            </div>
            
            <Link to={`/project/${project.id}`} style={{ display: 'inline-flex', alignItems: 'center', color: '#fff', fontSize: '0.85rem', fontWeight: 600, textTransform: 'uppercase', letterSpacing: '1px', textDecoration: 'none' }}>
              Dive Deeper <span style={{ marginLeft: '8px', color: 'var(--accent-cyan)' }}>→</span>
            </Link>
          </motion.div>
        ))}
      </div>
    </div>
  );
};

export default AllProjects;
